import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const rank_homepage = createAsyncThunk(
  'live/privilege/get_outfit_rank_list',
  async (arg: any, store: any) => {
    const resp = await http.post(
      'live/privilege/get_outfit_rank_list',
      {
        ...arg,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  list: Array<any>
  my_info?: any
}

const initialState: InitialStateType = {
  list: [],
}

export const DressUpBookRankSlice = createSlice({
  name: 'Animal_Parrot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(rank_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default DressUpBookRankSlice.reducer
export const DressUpBookRankActions = DressUpBookRankSlice.actions

export const useDressUpBookRankState = () => {
  const data = useSelector((state) => {
    return state.Animal_Parrot
  })
  return data
}
